import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { NavigationProp } from '@react-navigation/native';
import backIcon from '../../assets/icons/back.png';

interface LanguageSettingsScreenProps {
  navigation: NavigationProp<any>;
}

const LanguageSettingsScreen: React.FC<LanguageSettingsScreenProps> = ({ navigation }) => {
  const currentLanguage = 'en';

  const languages = [
    { code: 'en', name: 'English (US)', flag: '🇺🇸', available: true },
    { code: 'es', name: 'Español', flag: '🇪🇸', available: false },
    { code: 'fr', name: 'Français', flag: '🇫🇷', available: false },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', available: false },
    { code: 'it', name: 'Italiano', flag: '🇮🇹', available: false },
    { code: 'pt', name: 'Português', flag: '🇵🇹', available: false },
  ];

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={backIcon} style={styles.headerIcon} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Language</Text>
        <View style={{ width: s(24) }} />
      </View>

      <Text style={styles.sectionTitle}>App Language</Text>
      <Text style={styles.description}>
        MyFinalKey is currently available in English. Additional language support is coming soon.
      </Text>

      <ScrollView style={styles.languageList}>
        {languages.map((lang) => (
          <View
            key={lang.code}
            style={[
              styles.languageOption,
              currentLanguage === lang.code && styles.languageOptionSelected,
              !lang.available && styles.languageOptionDisabled,
            ]}
          >
            <Text style={styles.languageFlag}>{lang.flag}</Text>
            <View style={styles.languageTextContainer}>
              <Text style={[
                styles.languageName,
                currentLanguage === lang.code && styles.languageNameSelected,
                !lang.available && styles.languageNameDisabled,
              ]}>
                {lang.name}
              </Text>
              {!lang.available && (
                <Text style={styles.comingSoonText}>Coming Soon</Text>
              )}
            </View>
            {currentLanguage === lang.code && (
              <View style={styles.checkmark}>
                <Text style={styles.checkmarkText}>✓</Text>
              </View>
            )}
          </View>
        ))}
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: ms(20),
    paddingVertical: ms(15),
    marginTop: ms(10),
    backgroundColor: '#F3F6F8',
  },
  headerTitle: {
    fontSize: ms(18, 0.3),
    fontWeight: 'bold',
    color: '#333',
  },
  headerIcon: {
    width: s(24),
    height: s(24),
    tintColor: '#333',
  },
  sectionTitle: {
    fontSize: ms(16, 0.3),
    fontWeight: 'bold',
    color: '#333',
    marginHorizontal: ms(20),
    marginTop: ms(10),
    marginBottom: ms(8),
  },
  description: {
    fontSize: ms(14, 0.3),
    color: '#666',
    marginHorizontal: ms(20),
    marginBottom: ms(20),
    lineHeight: ms(20, 0.3),
  },
  languageList: {
    flex: 1,
    paddingHorizontal: ms(20),
  },
  languageOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: ms(15),
    paddingHorizontal: ms(20),
    borderRadius: ms(12),
    marginBottom: ms(10),
    backgroundColor: '#FFFFFF',
    borderWidth: ms(1),
    borderColor: '#d8dbdd',
  },
  languageOptionSelected: {
    backgroundColor: '#E6F9FA',
    borderColor: '#29BFC0',
  },
  languageOptionDisabled: {
    opacity: 0.6,
  },
  languageFlag: {
    fontSize: ms(24, 0.3),
    marginRight: ms(15),
  },
  languageTextContainer: {
    flex: 1,
  },
  languageName: {
    fontSize: ms(16, 0.3),
    color: '#333',
  },
  languageNameSelected: {
    color: '#29BFC0',
    fontWeight: 'bold',
  },
  languageNameDisabled: {
    color: '#999',
  },
  comingSoonText: {
    fontSize: ms(12, 0.3),
    color: '#999',
    marginTop: ms(2),
  },
  checkmark: {
    width: s(24),
    height: s(24),
    borderRadius: ms(12),
    backgroundColor: '#29BFC0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkmarkText: {
    color: '#FFFFFF',
    fontSize: ms(14, 0.3),
    fontWeight: 'bold',
  },
});

export default LanguageSettingsScreen; 